import { utils } from "../../utils/util";

const SelectComponent = ({
  label,
  value,
  option,
  name,
  handlechange,
  touched,
  error,
  landing,
}: any) => {
  return (
    <div>
      <label className="flex mb-2 mt-3 text-xl font-bold text-darkgray font-roboto  justify-start">
        {label}
      </label>
      <div className="px-2 bg-gray-50 border border-slate-300 rounded-lg  w-full block">
        <select
          onChange={(e) => {
            e.preventDefault();
            handlechange(e);
          }}
          id="default"
          name={name}
          value={value}
          className="text-gray-900 text-sm w-full p-2.5 pl-0 outline-none">
          <option value={""}>Please Select Option</option>
          {landing ? <option value={0}>for Landing </option> : null}
          {option?.length &&
            option?.map((elm: any) => (
              <option key={elm.id} value={elm.id}>
                {name === "tourId" ? utils.getEngTourName(elm.name) : elm.name}
              </option>
            ))}
        </select>
      </div>
      {error && touched && <p className="text-red-600">{error}</p>}
    </div>
  );
};

export default SelectComponent;
